export const DEFAULT_PAGE_TITLE = "Seedkit Admin";
export const DEFAULT_PAGE_DESCRIPTION = "Admin page for Seedkit (Social Enterprise Evaluation & Data Platform)";

export const LOGIN_COOKIE_KEY = "sklogin";

export const CONTEXT_STORAGE_KEY = "skcontext";

/*
export const NAV_DETAILS = [
   { 
      name: "Home", 
      path: "/admin",
      icon: "HomeIcon"
   },
   { 
      name: "Data Extracts", 
      path: "/admin/data",
      icon: "TableCellsIcon"
   },
   { 
      name: "Resources", 
      path: "/admin/resources",
      icon: "AcademicCapIcon"
   },
   { 
      name: "Mail Lists", 
      path: "/admin/mail",
      icon: "EnvelopeIcon"
   },
   { 
      name: "User Management", 
      path: "/admin/user",
      icon: "UserIcon"
   },
   { 
      name: "Web Analytics", 
      path: "/admin/analytics",
      icon: "ArrowTrendingUpIcon"
   },
];
*/

export const NAV_DETAILS = [
   { 
      name: "Home", 
      path: "/admin",
      icon: "HomeIcon"
   },
   { 
      name: "Mail Lists", 
      path: "/admin/mail",
      icon: "EnvelopeIcon"
   },
   { 
      name: "Web Analytics", 
      path: "/admin/analytics",
      icon: "ArrowTrendingUpIcon"
   },
];

export const EXPANDED_NAV_WIDTH = "w-64";
export const COLLAPSED_NAV_WIDTH = "w-17";

export const EXPANDED_NAV_MARGIN = "ml-64";
export const COLLAPSED_NAV_MARGIN = "ml-17";

export const LOGIN_ERROR = "There was an error logging you in. Please try again later.";
export const NOT_ENABLED_ALERT = "This function is not enabled in the current version of Seedkit";

export const ContextStatus = {
   OK: "ok",
   LOADING: "loading",
   ERROR: "error"
}

export const IntroText = {
   LOGGED_OUT: "Login to update resources, view analytics, extract data & mailing list & delete users",
   LOGGED_IN: "Use the button below to go to a site where you can update resources, view analytics, extract data & mailing list & delete users"
}

export const LOGIN_EXPIRY_CHECK_TIME = 10 * 1000; // 10 seconds
export const INACTIVE_EXPIRY_TIME = 60 * 60 * 1000; // 1 hour
